/*
 *		Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .directive('accUploadRequestActions', [
        '$translate',
        'confirmAction',
        'operationComplete',
        'promiseChain',
        'template',
        'uploadRequestLinkModal',
        'UploadRequestCreateUpdateModal',
        function (
            $translate,
            confirmAction,
            operationComplete,
            promiseChain,
            template,
            uploadRequestLinkModal,
            UploadRequestCreateUpdateModal
        ) {
            return {
                scope: {
                    selectedUploadRequests: '<',
                    resetSelection: '&',
                    reloadTable: '&'
                },
                templateUrl: template('requested_files/_upload_request_actions'),
                controller: ['$scope', function ($scope) {
                    $scope.canRevoke = function() {
                        return $scope.selectedUploadRequests.every(function(request) {
                            return request.isActive;
                        });
                    }

                    $scope.openGetLinkModal = function (selectedUploadRequest) {
                        uploadRequestLinkModal(selectedUploadRequest);
                    };

                    $scope.revokeUploadRequests = function(selectedUploadRequests) {
                        _confirm(selectedUploadRequests).then(function () {
                            _revokeSelectedUploadRequests(selectedUploadRequests);
                        });
                    };

                    $scope.editUploadRequest = function () {
                        var uploadRequestToEdit = $scope.selectedUploadRequests[0];
                        var target = uploadRequestToEdit.node;

                        if (angular.isUndefined(target.parents)) {
                            var parents = target.path.replace(/\/$/, '')
                                .split('/')
                                .map(function (pathItem) {
                                    return { name: pathItem };
                                });

                            parents.push({ name: target.name });

                            target.parents = parents;
                        }

                        UploadRequestCreateUpdateModal(target, uploadRequestToEdit)
                            .then(function () {
                                operationComplete('upload_requests_requested_files_actions_edit_request_updated_text');

                                $scope.resetSelection();
                                $scope.reloadTable();
                            });
                    };

                    function _confirm(selectedUploadRequests) {
                        return confirmAction({}, {
                            confirmTitle: $translate.instant('upload_requests_requested_files_actions_revoke_upload_requests', { COUNT: selectedUploadRequests.length }, 'messageformat'),
                            confirmSubmit: $translate.instant('Revoke'),
                            confirmBody: $translate.instant('upload_requests_requested_files_actions_revoke_upload_requests_confirmation_text', { COUNT: selectedUploadRequests.length }, 'messageformat'),
                        });
                    }

                    function _revokeSelectedUploadRequests(selectedUploadRequests){
                        promiseChain(
                            selectedUploadRequests.map(
                                function (uploadRequest) {
                                    return function() {
                                        return uploadRequest.$delete();
                                    };
                                }
                            )
                        ).then(function () {
                            operationComplete('upload_requests_requested_files_actions_revoke_upload_requests_success_text',  { COUNT: selectedUploadRequests.length }, 'messageformat');

                            $scope.resetSelection();
                            $scope.reloadTable();
                        });

                    };
                }]
            };
        }
    ]);
